import { render, staticRenderFns } from "./DeleteForumThreadModal.vue?vue&type=template&id=5b50eb68&scoped=true&"
import script from "./DeleteForumThreadModal.vue?vue&type=script&lang=js&"
export * from "./DeleteForumThreadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50eb68",
  null
  
)

export default component.exports